import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const OfferCountBadge = ({ offerCount }) => {
	const labels = useLabels();
	const offerLabel =
		offerCount === 1
			? labels.get('INCENTIVES_OFFER')
			: labels.get('INCENTIVES_OFFERS');
	return (
		<span className="vehicle-card__offer-count">
			{offerCount} {offerLabel} {labels.get('INCENTIVES_AVAILABLE')}
		</span>
	);
};

OfferCountBadge.propTypes = {
	offerCount: PropTypes.number.isRequired
};

export default OfferCountBadge;
